module.exports = __webpack_public_path__ + "static/media/SeaGarden.b3268e5f.png";